import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  SmartTooltip,
  StatusTags,
  TableAdv,
  useFormHandler,
} from "../../../../components";
import qb from "../../../../assets/qb.svg";
import { dateFormator, mapTableRows } from "../../../../utils";
import { DropDownoptionsquickbooks } from "../../../../assets/data/projectData";
import { useNavigate } from "react-router-dom";
import {
  qbApiStart,
  resetAllQBData,
} from "../../../../redux/slices/quickBooks/quickBooksSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  clearClientData,
  getClientsStart,
} from "../../../../redux/slices/client/clientSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  addInvoicesStart,
  clearInvoicesdata,
  getAllInvoicesStart,
  getCurrentInvoiceStart,
} from "../../../../redux/slices/invoices/invoicesSlice";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import axios from "axios";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import InvoiceDetails from "../../Invoices/Invoices/InvoiceDetails";

const Invoice = ({ setActiveTab, dropdowns }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [qbLoading, setQbLoading] = useState(false);

  console.log("selectedRowIds", selectedRowIds);
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.invoices?.data || 0;
  const { allInvoices, loading } = useSelector((state) => state.invoices);
  const isLoading = loading;
  const allInvoicesTableData = allInvoices?.data || [];
  const [sortConfig, setSortConfig] = useState({ field: "uiid", direction: 1 });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Search: "",
    Timesheets: "",
    status: "",
  });
  const formatCurrency = (amount) => `$${Number(amount).toLocaleString()}`;

  const handleClickForInvoice = (invoiceId) => {
    if (!invoiceId)
      return showToast(
        "Something went wrong while previewing invoice",
        "error",
        3000,
      );
    dispatch(
      getCurrentInvoiceStart({
        filters: { uiid: { type: "NONE", value: invoiceId } },
        coll: "Invoice",
        ref: "Client Employee Placement Timesheet",
        incl: ["", "firstName lastName", "", "attachments"],
      }),
    );
    setSelectedInvoice(invoiceId);
  };

  // console.log("formData", formData);
  const columns = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
      render: (row) => {
        const isSynced = row?.qbSync?.id;
        const hasError = row?.qbSync?.error;

        const tooltipText = isSynced
          ? "Synced with QB"
          : hasError
            ? "QB Sync Failed"
            : "Not Synced with QB";

        return (
          <div className="flex items-center gap-3 group">
            <SmartTooltip description={tooltipText} noicon>
              <div
                className={`flex gap-2 items-center cursor-pointer ${
                  isSynced
                    ? "text-success"
                    : hasError
                      ? "text-danger"
                      : "text-linkblue"
                }`}
                onClick={() => handleClickForInvoice(row.id)}
              >
                {row.invoiceNumber}
              </div>
            </SmartTooltip>
          </div>
        );
      },
      sortable: false,
    },

    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },
    {
      key: "recordType",
      label: "Record Type",
      sortable: false,
    },
    {
      key: "clientName",
      label: "Client Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.clientName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            {row?.clientName}
          </div>
        </SmartTooltip>
      ),
      sortable: false,
    },
    {
      key: "employeeName",
      label: "Employee Name",
      width:"min-w-[250px] max-w-[300px]",
      render: (row) => (
        <SmartTooltip
          description={row?.employeeName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            {row?.employeeName}
          </div>
        </SmartTooltip>
      ),
      sortable: false,
    },
    {
      key: "invoicDate",
      label: "Invoice Date",
      sortable: false,
    },
    {
      key: "dueDate",
      label: "Due Date",
      sortable: false,
    },
    {
      key: "statementMemoPeriod",
      label: "Statement Memo Period",
      sortable: false,
    },
    {
      key: "invoiceAmount",
      label: "Invoice Amount",
      sortable: false,
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
      sortable: false,
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      sortable: false,
    },
  ];

  const rowdata = [
    {
      invoiceNumber: "INV-1001",
      businessUnit: "Tektree",
      recordType: "Invoice",
      clientName: "ABC Corp",
      employeeName: "John Doe",
      invoicDate: "06/17/2025",
      dueDate: "07/17/2025",
      statementMemoPeriod: "05/1/2025-05/31/2025",
      invoiceAmount: "60000 USD",
      receivedAmount: "50000 USD",
      status: "Submitted",
      syncstatus: "Synced",
    },
    {
      invoiceNumber: "INV-1002",
      businessUnit: "Tektree",
      recordType: "Invoice",
      clientName: "XYZ Ltd",
      employeeName: "Jane Smith",
      invoicDate: "06/17/2025",
      dueDate: "07/17/2025",
      statementMemoPeriod: "05/1/2025-05/31/2025",
      invoiceAmount: "60000 USD",
      receivedAmount: "50000 USD",
      status: "Submitted",
      syncstatus: "Pending",
    },
    {
      invoiceNumber: "INV-1003",
      businessUnit: "Tektree",
      recordType: "Invoice",
      clientName: "TechWave Inc",
      employeeName: "Arjun Reddy",
      invoicDate: "06/17/2025",
      dueDate: "07/17/2025",
      statementMemoPeriod: "05/1/2025-05/31/2025",
      invoiceAmount: "60000 USD",
      receivedAmount: "50000 USD",
      status: "Submitted",
      syncstatus: "In Progress",
    },
  ];

  const fetchInvoices = async () => {
    dispatch(
      qbApiStart({
        method: "GET",
        entity: "invoices",
        // body: {
        //
        // },
      })
    );
  };

  //data fetching
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "invoices",
        coll: "Invoice",
        //filters: item.filters,
      })
    );
    dispatch(
      getAllInvoicesStart({
        limit,
        page,
        filters: {},
        coll: "Invoice",
        // ret:"uiid"
        // ret: "invoiceNum clientId invoiceDate dueDate uiid",
        ret: "",
        ref: "Client Employee",
        incl: ["", "firstName lastName"],
        // incl: ["", "firstName lastName"],
      })
    );
    return () => {
      dispatch(clearInvoicesdata());
    };
  }, [dispatch, page, limit, sortConfig, forceRerenderKey]);

  //data mapper
  const rowData2 =
    allInvoicesTableData?.map((invoice) => ({
      id: invoice?.uiid,
      qbSync: invoice?.qbSync,
      invoiceNumber: invoice?.invoiceNum || "-",
      businessUnit: "-",
      recordType: "-",
      clientName: invoice?.clientId?.businessName || "-",
      employeeName:
        invoice?.employeeId?.firstName + " " + invoice?.employeeId?.lastName ||
        "-",
      invoicDate: dateFormator(invoice?.invoiceDate, "month-day-year") || "-",
      dueDate: dateFormator(invoice?.dueDate, "month-day-year") || "-",
      // statementMemoPeriod: "05/1/2025-05/31/2025",
      statementMemoPeriod:
        `${dateFormator(
          invoice?.memoPeriod?.from,
          "month-day-year"
        )} - ${dateFormator(invoice?.memoPeriod?.to, "month-day-year")}` ||
        "-",
      invoiceAmount: invoice?.amounts?.invoiced
        ? `${formatCurrency(invoice?.amounts?.invoiced)}`
        : "-" || "-",
      receivedAmount: invoice?.amounts?.received
        ? `${formatCurrency(invoice?.amounts?.received)}`
        : "-" || "-",
      // status: "Submitted",
      status:
        invoice?.status === 1
          ? "draft"
          : invoice?.status === 2
          ? "sent"
          : invoice?.status === 3
          ? "paid"
          : invoice?.status === 4
          ? "overdue"
          : "cancelled" || "-",
      syncstatus:
        invoice?.qbSync?.status === 1
          ? "Not-Synced"
          : invoice?.qbSync?.status === 2
          ? "Synced"
          : invoice?.qbSync?.status === 3
          ? "Partial-Synced"
          : "Not-Synched" || "-",
    })) || [];

  const mappedRows = mapTableRows(rowData2, columns);
  const handleSearch = () => {
    setActiveTab(Number(formData.Timesheets));
  };

  const forceRerender = () => {
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  //working
  const handleUpdate = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);
      return;
    }
    let baseUrl = WORKFORCE_API_URL;
    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;
      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      let successCount = 0;
      let failedCount = 0;

      const buildClientPayload = (data) => ({
        postActions: ["AddQBToClient"],
        payload: {
          // businessName: (data?.businessName || "").replace(/[^\w\s]/g, ""),
          businessName: data?.businessName || "",
          uiid: data?.uiid || null,
          email: data?.email || [],
          phone: (data?.phone || []).map((p) => ({
            code: p?.code || "",
            number: String(p?.number || ""),
          })),
          roleContacts: (data?.roleContacts || []).map((rc) => ({
            role: rc?.role || "",
            email: rc?.email || [],
            phone: (rc?.phone || []).map((p) => ({
              code: p?.code || "",
              number: String(p?.number || ""),
            })),
          })),
          federalId: data?.federalId || "",
          website: data?.website || "",
          recordStatus: data?.recordStatus || null,
          ownership: data?.ownership || null,
          generalInfo: data?.generalInfo || null,
          contacts: data?.contacts || [],
          additionalInfo: data?.additionalInfo || "",
          documents: (data?.documents || []).map((doc) => ({
            placement: doc?.placement || [],
            list: doc?.list || [],
          })),
          placements: data?.placements || [],
          addedBy: data?.addedBy || null,
          addedOn: data?.addedOn || new Date().toISOString(),
        },
      });

      const buildInvoicePayload = (invoice) => {
        const obj = invoice;
        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),
          uiid: obj?.uiid || null,
          clientId: obj?.clientId.uiid || null,
          invoiceCreatedBy: obj?.invoiceCreatedBy || null,
          invoiceNum: obj?.invoiceNum || null,
          poNum: obj?.poNum || null,
          type: obj?.type || null,
          frequency: obj?.frequency || null,
          frequencyPeriod: obj?.frequencyPeriod || null,
          status: obj?.status || null,
          inclPOEmail: obj?.inclPOEmail || null,
          employeeId: obj?.employeeId._id || null,
          jobId: obj?.jobId._id || null,
          timesheet: obj?.timesheet || null,
          address: {
            billing: {
              ...(obj?.address.billing || null),
              zipCode: obj?.address.billing.zipCode || "",
            },
            from: {
              ...(obj?.address.from || null),
              zipCode: obj?.address?.from.zipCode || "",
            },
          },
          netTerms: obj?.netTerms || null,
          invoiceDate: obj?.invoiceDate || null,
          shippedDate: obj?.shippedDate || null,
          dueDate: obj?.dueDate || null,
          location: obj?.location || null,
          amounts: obj?.amounts || null,
          recipients: obj?.recipients || null,
          serviceSummary: obj?.serviceSummary.map(
            ({ ss, activity, quantity, rate, attachments, inclMailAttch }) => ({
              ss,
              activity,
              quantity,
              rate,
              amount: +(Number(quantity) * Number(rate)).toFixed(2),
              attachments,
              inclMailAttch,
            })
          ),
          finalBill: {
            subTotal: obj?.finalBill?.subTotal || null,
            discounts: obj?.finalBill?.discounts.map(
              ({ name, type, value }) => ({
                name,
                type,
                value,
              })
            ),
          },
          notes: obj?.notes || null,
          inclNotesPdf: obj?.inclNotesPdf || null,
          memo: obj?.memo || null,
          memoPeriod: obj?.memoPeriod || null,
          additionalInfo: obj?.additionalInfo || null,
          currency: obj?.currency || null,
          addedBy: obj?.addedBy || null,
          addedOn: obj?.addedOn || null,
          attachments: [],
          payableTo: "",
          category: "",
          class: "",
        };
      };

      for (const invoice of invoiceData) {
        const clientData = invoice.clientId || {};
        const isClientSynced = Boolean(clientData?.qbSync?.id);

        if (!isClientSynced) {
          try {
            const clientPayload = buildClientPayload(clientData);
            await axios.post(`${baseUrl}/qb/customers`, clientPayload, {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            });
          } catch (err) {
            showToast(
              `${err?.response?.data?.error || "Unknown error"}`,
              "warning",
              5000
            );
            console.error("Customer Sync Failed:", err.response || err);
            failedCount++;
            continue;
          }
        }

        const isInvoiceSynced = Boolean(invoice?.qbSync?.id);
        const invoicePayload = buildInvoicePayload(invoice);

        try {
          if (!isInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                postActions: ["AddQBToInvoice"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            let failedUploads = 0;

            if (
              invoicePayload?.serviceSummary?.length > 0 ||
              invoicePayload?.serviceSummary?.some(
                ({ attachments }) => attachments?.length > 0
              )
            ) {
              for (const service of invoicePayload.serviceSummary) {
                if (service?.attachments?.length > 0) {
                  for await (const file of service.attachments) {
                    try {
                      const filesRes = await axios.post(
                        `${baseUrl}/qb/uploads`,
                        {
                          payload: {
                            uiid: invoicePayload.uiid,
                            fileName: service?.ss,
                            inclToMail: !!service.inclMailAttch,
                            parentRef: {
                              entity: "Invoice",
                              id: res?.data?.data?.response?.Id,
                            },
                            attachment: file,
                          },
                        },
                        {
                          headers: { "Content-Type": "application/json" },
                          withCredentials: true,
                        }
                      );
                    } catch (err) {
                      failedUploads++;
                    }
                  }
                }
              }
              if (failedUploads > 0) {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  })
                );
                showToast(
                  `${failedUploads} attachment${
                    failedUploads > 1 ? "s" : ""
                  } failed to upload`,
                  "info",
                  3000
                );
              } else {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  })
                );
              }
            }

            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,

              {
                update: true,
                postActions: ["AddQBToInvoice"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              }
            );
            let failedUploads = 0;

            // if (
            //   invoicePayload?.serviceSummary?.length > 0 ||
            //   invoicePayload?.serviceSummary?.some(
            //     ({ attachments }) => attachments?.length > 0
            //   )
            // ) {
            //   for (const service of invoicePayload.serviceSummary) {
            //     if (service?.attachments?.length > 0) {
            //       for await (const file of service.attachments) {
            //         try {
            //           const filesRes = await axios.post(
            //             `${baseUrl}/qb/uploads`,
            //             {
            //               payload: {
            //                 uiid: invoicePayload.uiid,
            //                 fileName: service?.ss,
            //                 inclToMail: !!service.inclMailAttch,
            //                 parentRef: {
            //                   entity: "Invoice",
            //                   id: res?.data?.data?.response?.Id,
            //                 },
            //                 attachment: file,
            //               },
            //             },
            //             {
            //               headers: { "Content-Type": "application/json" },
            //               withCredentials: true,
            //             }
            //           );
            //         } catch (err) {
            //           failedUploads++;
            //         }
            //       }
            //     }
            //   }
            // }

            // if (failedUploads > 0) {
            //   showToast(
            //     `${failedUploads} attachment${
            //       failedUploads > 1 ? "s" : ""
            //     } failed to upload`,
            //     "info",
            //     3000
            //   );
            // }
            // dispatch(
            //   addInvoicesStart({
            //     coll: "Invoice",
            //     uiid: invoicePayload?.uiid,
            //     qbId: invoicePayload?.qbSync?.id,
            //     syncFromQB: true,
            //     supressToast:true
            //   })
            // );
            successCount++;
          }
        } catch (err) {
          showToast(
            `${err?.response?.data?.error || "Unknown error"}`,
            "warning",
            5000
          );
          console.error("Invoice Sync Error:", err);
          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,
        failedCount > 0 ? "warning" : "success",
        6000
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);
      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };
  const handleQbDispatchSync = async () => {
    try {
      setQbLoading(true);
      if (selectedRowIds.length === 0) {
        showToast("Please select at least one invoice", "info", 5000);
        return;
      }

      const selectedIds = selectedRowIds;
      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice.uiid)
      );

      let successCount = 0;
      let notSyncedCount = 0;

      for (const invoice of invoiceData) {
        if (!invoice?.qbSync?.id) {
          notSyncedCount++;
          continue;
        }

        try {
          await new Promise((resolve) => {
            dispatch(
              addInvoicesStart({
                coll: "Invoice",
                uiid: invoice?.uiid,
                qbId: invoice?.qbSync?.id,
                syncFromQB: true,
                supressToast: true,
                onSuccess: () => {
                  successCount++;
                  resolve();
                },
                onError: () => {
                  notSyncedCount++;
                  resolve();
                },
              })
            );
          });
        } catch (error) {
          console.error("Error during sync", error);
        }
      }

      showToast(
        `QB Sync Completed: ${successCount} succeeded, Update ${notSyncedCount} Invoice's to sync`,
        successCount > 0 ? "success" : "warning",
        4000
      );
    } catch (error) {
      console.error("Error during sync", error);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  return (
    <div className="flex flex-col overflow-hidden flex-1">
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <TableAdv
        tableId={"invoices_qbintegration_invoice"}
        // onSelectionChange={handleSelectionChange}
        onSelectionChange={(ids) => setSelectedRowIds(ids)}
        rows={mappedRows}
        columns={columns}
        // limit={100}
        showCheckbox
        serverPagination={true}
        totalCount={totalCount}
        defaultSelectedRows={selectedRowIds}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className="flex flex-wrap items-center gap-3 ml-2">
                  <FormFieldSet
                    type="text"
                    noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    // onChange={(value) => handleSearch(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />

                  <Button title="Search" onClick={handleSearch} />

                  <Button
                    title="QB Integration Profiles"
                    color="info"
                    onClick={() =>
                      navigate("/quickbooks/qb-integration-profile")
                    }
                  />

                  <div className="flex items-center">
                    {selectedRowIds?.length > 0 && (
                      <>
                        {/* <button
                          onClick={() => handleQbDispatchSync()}
                          className="mx-1"
                        >
                          <Avatar alt={"sync"} size="xs" outline />
                        </button> */}
                        <Button
                          title="Sync to QB"
                          color="success"
                          onClick={() => handleQbDispatchSync()}
                        />
                      </>
                    )}
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <InvoiceDetails
          invoice={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
        />
      </Modal>
    </div>
  );
};

export default Invoice;
